var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlinkFLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 24,
    viewBox: "0 0 93 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85706 6.85706L0 0V17.1427L6.85706 23.9998V17.4855L13.3713 23.9997H23.314L15.0855 15.7712H6.85706V6.85706Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9136 5.82812V23.9993H38.0564V15.428L43.8849 23.9993H50.0562L43.477 14.6004L50.0562 5.82812H43.8849L38.0564 13.7137V5.82812H32.9136Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.085 23.9993V5.82812H56.2278V23.9993H51.085Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0231 10.234C58.5066 10.7305 59.1132 10.9788 59.8427 10.9788C60.5891 10.9788 61.1999 10.7305 61.6749 10.234C62.15 9.73742 62.3875 9.12725 62.3875 8.40346C62.3875 7.67967 62.15 7.0695 61.6749 6.57295C61.1999 6.0764 60.5891 5.82812 59.8427 5.82812C59.1132 5.82812 58.5066 6.0764 58.0231 6.57295C57.5396 7.0695 57.2979 7.67967 57.2979 8.40346C57.2979 9.12725 57.5396 9.73742 58.0231 10.234ZM57.2563 11.6566V23.9993H62.3991V11.6566H57.2563Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4844 5.82812V23.9992H82.6272V18.1708L85.7128 23.9993H91.1985L87.2647 17.3422L90.8556 11.6566H85.37L82.6272 16.4566V5.82812H77.4844Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4277 11.6582V24.0009H68.5705V17.3059C68.5718 16.9911 68.6368 16.7688 68.7628 16.5438C68.89 16.3165 69.0681 16.144 69.2972 16.0262C69.5262 15.9083 69.7849 15.8494 70.0733 15.8494C70.4975 15.8494 70.8495 15.9799 71.1294 16.2408C71.4094 16.5017 71.5493 16.8762 71.5493 17.3643L71.5493 24.0009H76.4561L76.4561 16.2282C76.4561 15.0867 76.3336 14.5491 75.9264 13.8674C75.5192 13.1857 74.9636 12.6471 74.2595 12.2515C73.5555 11.856 72.7539 11.6582 71.8547 11.6582C70.8537 11.6582 69.8276 11.7061 69.1699 12.2389C68.6611 12.6511 68.5808 13.1041 68.5705 13.2879V11.6582H63.4277ZM68.5705 13.403C68.5705 13.383 68.5705 13.3725 68.5705 13.3725C68.5705 13.3725 68.5675 13.3417 68.5705 13.2879V13.403ZM68.5705 17.303C68.5721 16.2234 68.5707 13.7083 68.5705 13.403V17.303ZM68.5705 17.303V17.3059C68.5705 17.309 68.5705 17.3122 68.5705 17.3153C68.5705 17.3112 68.5705 17.3071 68.5705 17.303Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7996,
    cy: 9.25665,
    r: 3.42853,
    fill: "#7660FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlinkFLogo);
export default __webpack_public_path__ + "static/media/KlinkFLogo.9aff1c06021662217d2c5a3c93682822.svg";
export { ForwardRef as ReactComponent };